// extracted by mini-css-extract-plugin
module.exports = {"card":"voice-card_card__blqq_","artist_image":"voice-card_artist_image__I9uSV","image":"voice-card_image__emcnq"};